























import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import BusinessUnitService from '@/domain/business-unit/service/business-unit.service';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';

@Component
export default class NotifyCancellationCard extends Vue {
  @Prop({ required: true, default: '' }) private businessUnitId!: string;

  notifyCancellationEnabled: boolean = false;

  created() {
    this.loadNotifyCancellation();
  }

  @Watch('businessUnitId')
  onBusinessUnitIdChanged() {
    this.loadNotifyCancellation();
  }

  loadNotifyCancellation() {
    if (!this.businessUnitId) return;
    const businessUnit = UserBusinessUnitService.businessUnits
      .find((unit) => unit.id === this.businessUnitId);
    this.notifyCancellationEnabled = businessUnit
      ? businessUnit.enableNotifyCancelallation
      : false;
  }

  handleSwitchNotifyCancellation() {
    BusinessUnitService.switchEnableNotifyCancellation(
      this.businessUnitId,
      this.notifyCancellationEnabled,
    )
      .then(() => {
        const businessUnit = UserBusinessUnitService.businessUnits
          .find((unit) => unit.id === this.businessUnitId);
        if (businessUnit) {
          businessUnit.enableNotifyCancelallation = this.notifyCancellationEnabled;
        }
        VbSnackbarService.showSuccess('Configuração salva com sucesso!');
      })
      .catch((err: any) => {
        this.notifyCancellationEnabled = !this.notifyCancellationEnabled;
        VbSnackbarService.handleHttpError(err);
      });
  }
}
